module.exports = __webpack_public_path__ + "icon_file_download-4b5c054e76b0df3cbbc851854cd10c3c.svg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/icon_file_download.svg
// module id = 262
// module chunks = 88